export const breakpoints = {
  phone: 700,
  small: 700,
  medium: 900,
  mediumBig: 1120,
  big: 1330,
}
